import rootReducer from "@app/reducers";
import { configureStore } from "@reduxjs/toolkit";


export const store = configureStore({
    reducer:rootReducer,
    devTools: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
});
/**
 * creates a Redux store, and also automatically configures the Redux DevTools extension so that you can inspect the store while developing.
 */
